<script lang="ts">
import { defineComponent } from 'vue'
import RequestDueDate from './request-duedate.vue'
import RequestFulfillmentDate from './request-fulfillment-date.vue'
import RequestReceivedDate from './request-received-date.vue'
import { mapState } from 'vuex'
import RequestExpirationDate from './request-expiration-date.vue'
import NrLoadingAnimation from '@nextrequestco/components/src/components/NrLoadingAnimation'

export default defineComponent({
  name: 'request-dates',
  components: {
    RequestFulfillmentDate,
    RequestDueDate,
    RequestReceivedDate,
    RequestExpirationDate,
    NrLoadingAnimation
  },
  props: {
    prettyId: {
      type: String,
      required: true
    },
    canSeeRequestDueDate: {
      type: Boolean
    },
    dueDate: {
      type: String
    },
    received: {
      type: String
    },
    canSeeRequestExpirationDate: {
      type: Boolean
    },
    exemptFromRetention: {
      type: Boolean
    },
    fulfillment: {
      type: String
    },
    expiration: {
      type: String
    },
    requestSubmitType: {
      type: String
    }
  },
  computed: {
    ...mapState(['account']),
    ...mapState('request_show', ['filteredRequestLoading']),
    canSeeFulfillmentDate() {
      return (
        this.$can('read', 'staff_only_items') &&
        this.account.anticipated_fulfillment_date
      )
    }
  }
})
</script>

<template>
  <article class="panel request-date-panel p-bottom-4">
    <p
      class="panel-heading has-background-light has-text-weight-semibold is-size-4"
    >
      Dates
    </p>
    <div class="panel-content" v-if="!filteredRequestLoading">
      <RequestDueDate
        v-if="canSeeRequestDueDate"
        :prettyId="prettyId"
        :date="dueDate"
      />
      <RequestReceivedDate
        v-if="received"
        :prettyId="prettyId"
        :date="received"
        :requestSubmitType="requestSubmitType"
      />

      <RequestFulfillmentDate
        v-if="canSeeFulfillmentDate"
        :prettyId="prettyId"
        :date="fulfillment"
      />

      <RequestExpirationDate
        v-if="canSeeRequestExpirationDate"
        :prettyId="prettyId"
        :exempt="exemptFromRetention"
        :expiration="expiration"
      />
    </div>
    <NrLoadingAnimation v-else :count="3" />
  </article>
</template>

<style lang="scss">
.datepicker {
  .dropdown-menu {
    min-width: 21rem;
  }

  .pagination {
    .pagination-previous {
      margin-top: 0;
      margin-bottom: 0;
    }
    .pagination-list {
      margin-top: 0;
    }
  }
}
</style>
